import "@fortawesome/fontawesome-free/css/all.min.css";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import FullPageLoading from "./components/library/FullPageLoading/FullPageLoading";
import configureStore from "./config";
import {
  fetchParticipantStudyStatus,
  initializeSession,
} from "./modules/login";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import { sendNotification } from "./components/ToastManager/ToastManager";
import { ToastType } from "./components/ToastManager/constants";
import { setupInterceptors } from "./modules/http";
import "./i18n";
import { refreshAppLanguage } from "./i18n/helpers";

const { store } = configureStore();
setupInterceptors(store);
class Launcher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    refreshAppLanguage();

    store
      .dispatch(initializeSession())
      .then(() => {
        store.dispatch(fetchParticipantStudyStatus()).finally(() => {
          this.setState({ loading: false });
        });

        //Don't update route on load, we'll lose url data for some functionallity.
      })
      .catch((e) => {
        this.setState({ loading: false });
        sendNotification(e, ToastType.ERROR);
      });
  }

  render() {
    return this.state.loading && this.state.token === undefined ? (
      <FullPageLoading />
    ) : (
      <Provider store={store}>
        <App />
      </Provider>
    );
  }
}
ReactDOM.render(<Launcher />, document.getElementById("root"));
serviceWorker.unregister();
